import React from "react";

function Header() {
  return (
    <header>
      <div>
        <h1 className=" text-xl sm:text-4xl font-bold mx-3 mt-4 text-fuchsia-900 text-center">
          Recommendations Tracker
        </h1>
      </div>
    </header>
  );
}

export default Header;
